<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e194415"><a href="#/Burk_9781418513399_epub_c3_r1#Anch00315" id="Anch0023"><b>Part 1</b><br/><b>BUSINESS</b><br/><b>BY THE</b><br/><b>BOOK</b></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Burk_9781418513399_epub_c8_r1.vue?19db9cb1